import { collection, query, where, getDocs, orderBy } from 'firebase/firestore'
import { db } from '../firebase'

export class TxnSummaryService {
  constructor(customerName) {
    this.customerName = customerName
    this.collectionName = 'txn_summary'
  }

  formatDateToInt(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return parseInt(`${year}${month}${day}`, 10)
  }

  getDateRange(period) {
    const today = new Date()
    today.setHours(23, 59, 59, 999)
    
    const startDate = new Date()
    startDate.setHours(0, 0, 0, 0)
    
    switch (period) {
      case 'today':
        break
      case '7d':
        startDate.setDate(startDate.getDate() - 6)
        break
      case '30d':
        startDate.setDate(startDate.getDate() - 29)
        break
      case '90d':
        startDate.setDate(startDate.getDate() - 89)
        break
      default:
        startDate.setDate(startDate.getDate() - 6)
    }
    
    return {
      startDate: this.formatDateToInt(startDate),
      endDate: this.formatDateToInt(today)
    }
  }

  async getLiveDeviceCounts(period = '7d') {
    try {
      if (!this.customerName) {
        throw new Error('Customer name is required')
      }

      const { startDate, endDate } = this.getDateRange(period)
      
      console.log(`[TxnSummary] Fetching live device counts for ${this.customerName} from ${startDate} to ${endDate}`)

      const txnRef = collection(db, this.collectionName)
      const q = query(
        txnRef,
        where('customer', '==', this.customerName),
        where('date', '>=', startDate),
        where('date', '<=', endDate),
        orderBy('date', 'asc')
      )

      const snapshot = await getDocs(q)
      const data = []

      snapshot.forEach((doc) => {
        const docData = doc.data()
        const dateStr = String(docData.date)
        const day = dateStr.slice(6, 8)
        const month = dateStr.slice(4, 6)
        const year = dateStr.slice(0, 4)
        const formattedDate = `${day}-${month}-${year}`
        
        data.push({
          date: docData.date,
          dateFormatted: formattedDate,
          live: docData.live || 0
        })
      })

      console.log(`[TxnSummary] Loaded ${data.length} days of data`)

      return data
    } catch (error) {
      console.error('[TxnSummary] Error fetching live device counts:', error)
      throw error
    }
  }
}

export function createTxnSummaryService(userClaims) {
  if (!userClaims || !userClaims.customer) {
    throw new Error('Valid user claims with customer name required')
  }
  return new TxnSummaryService(userClaims.customer)
}
